import { render } from "./AddLocationShelfModal.vue?vue&type=template&id=8be304c4"
import script from "./AddLocationShelfModal.vue?vue&type=script&lang=js"
export * from "./AddLocationShelfModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__